import type { WorkspaceActivityAction } from '../services/activityService'

export const HELPER_BLOCKER_ACTIVITY_ACTIONS = [
  'HELPER_BLOCKER_RAISED',
  'HELPER_REPLENISHMENT_REQUESTED',
] as const satisfies readonly WorkspaceActivityAction[]

export type HelperBlockerActivityAction = (typeof HELPER_BLOCKER_ACTIVITY_ACTIONS)[number]

export const HELPER_BLOCKER_REASONS = [
  'MISSING_INFO',
  'MISSING_STOCK',
  'ACCESS_ISSUE',
  'DEPENDENCY_WAIT',
  'SAFETY_RISK',
  'OTHER',
] as const

export type HelperBlockerReason = (typeof HELPER_BLOCKER_REASONS)[number]

export const HELPER_BLOCKER_REASON_LABELS: Record<HelperBlockerReason, string> = {
  MISSING_INFO: 'Missing info',
  MISSING_STOCK: 'Missing stock',
  ACCESS_ISSUE: 'Access issue',
  DEPENDENCY_WAIT: 'Waiting on dependency',
  SAFETY_RISK: 'Safety risk',
  OTHER: 'Other',
}

export type HelperOpenBlocker = {
  id: string
  workspaceId: string
  itemId: string
  itemTitle: string
  actorId: string
  actorName: string | null
  action: HelperBlockerActivityAction
  reason: HelperBlockerReason
  note: string
  createdAtMs: number
  stockItemIds: string[]
  shortagesById: Record<string, { name?: string; available: number; required: number; unit?: string }>
}
